import React, { useEffect } from 'react';
import {InputField} from '../../../utility/form';

import useForgotPassword from './useLeftPanel';
import { useNavigate, Outlet } from 'react-router-dom';
import { Header } from '../../Layout';

const LeftPanel = () => {
  const navigate = useNavigate();
  const theme = localStorage.getItem('theme');
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [])
  return (<>
    <div className="container-fluid g-0 min-vh-100 d-flex flex-column flex-lg-row left-panel-signin">
      <div className="col-lg-6 col-12 p-0">
        <div className="left-panel-bg d-flex flex-column justify-content-center  h-100">
          <i
            className="bi bi-arrow-left-short"
            style={{ fontSize: '1.8rem', cursor: 'pointer', padding: '1rem', display: 'inline-block' }}
            onClick={() => navigate('/')}
          ></i>
          <div className="left-panel">
              <div className="" style={{ fontSize: '1.1rem', opacity: 0.85 }}>
                Clarity And Confidence In Every Transaction.
              </div>
              <div className="headline mt-3" style={{ fontSize: '3rem', lineHeight: 1.1 }}>
                Maximize Your Profits<br />With Full Confidence<br />And Clarity
              </div>
              <div className="mt-5" style={{ fontSize: '1.2rem', opacity: 0.95}}>
                Are you sure you're getting the complete amount for every product sold on Lorem ipsum? With our platform, you gain full visibility into your sales and earnings.<br /><br />
                Stay informed, take charge, and ensure every rupee you’ve earned reaches you.
              </div>
              <hr style={{ background: 'rgba(255,255,255,.43)' }} />
              <div style={{ fontWeight: 700, fontSize: '1.5rem', alignItems: 'center', gap: 6 }} className="mt-5 mb-0">
                  <i className="bi bi-search"></i> Transparent
                <span style={{ fontWeight: 300, fontSize: 30, marginLeft: 8, marginRight: 8 }}>|</span>
                  <i className="bi bi-currency-dollar"></i> Accurate
                <span style={{ fontWeight: 300, fontSize: 30, marginLeft: 8, marginRight: 8 }}>|</span>
                 <i className="bi bi-graph-up-arrow"></i> Seller-Focused
              </div>
          </div>
        </div>
      </div>
      <div
        className="col-lg-6 col-12 d-flex align-items-center justify-content-center p-0 form-section"
      >
        <Outlet />
      </div>
    </div>
  </>
  );
};

export default LeftPanel;


